import { defineComponent as _defineComponent } from 'vue'
import { markRaw, defineAsyncComponent, ref } from 'vue'
import { useSubmit } from '@/composables/useSubmit'
import { useRouter } from 'vue-router'
import { accountApi } from '@/services/account.service'
import { prefixLanguage } from '@/utils/urls'
import { CHAIN_CREATE_VIEW_NAME } from '@/modules/cabinet/routes'

import useGlobal from '@/composables/useGlobal'
import useField from '@/composables/useField'
import { composeTransformers, simplifiers } from '@/utils/transformers'

import { CREATE_UPLOAD_URL } from '@/services/general.service'
import { useModalOpener } from '@/composables/useModalOpener'


export default /*@__PURE__*/_defineComponent({
  __name: 'Doctor',
  props: {
    currentUserType: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const DoctorSuccessModal = defineAsyncComponent(
  () => import('@/modules/auth/components/roles/DoctorSuccessModal.vue')
)

const router = useRouter()

const props = __props

const profileTransformFrom = composeTransformers(
  simplifiers.simple('lastName'),
  simplifiers.simple('firstName'),
  simplifiers.simple('middleName'),
  simplifiers.simple('birthday'),
  simplifiers.select('avatar'),
  simplifiers.same('recaptcha')
)

const { $t } = useGlobal()
const formRef = ref(null)

const form = ref({
  lastName: '',
  firstName: '',
  middleName: '',
  avatar: '',
  birthday: '',
})

const isLoad = ref(false)

const FIELDS = ref([
  useField('avatar', $t('Logo'), {
    size: '12',
    classes: 'default-dropzone-wrap limited-preview-height',
    component: 'd-control-image',
    currentUrl: CREATE_UPLOAD_URL,
    field: 'file',
    class: 'd-control-image',
    cropperProps: {
      options: {
        stencilProps: {
          aspectRatio: 1 / 1,
        },
      },
    },
    slots: [
      {
        name: 'placeholder',
        component: 'up-image-label',
        props: {
          text: $t('Upload avatar'),
          placeholder: $t('Select avatar or drag it here.'),
          icon: 'i-circle-fading-plus',
        },
      },
    ],
  }),
  useField('lastName', $t('Last name'), { rules: { required: true, anthroponym : true } }),
  useField('firstName', $t('First name'), { rules: { required: true, anthroponym : true } }),
  // useField('middleName', $t('Middle name'), { rules: { anthroponym: true } }),
  // useField('birthday', $t('Birthday'), {
  //   component: 'd-control-datepicker',
  // }),
])

const send = async (sendData) => {
  isLoad.value = true
  try {
    await accountApi.setRole.execute(
      {},
      {
        role: props.currentUserType,
      }
    )
    const { data } = await accountApi.update.execute(
      {},
      {
        ...sendData,
      }
    )

    let isGoToCreate = false
    function redirectToChainForm(val) {
      // isGoToCreate = val
      // if (val) {
      //   window.location.href = router.resolve({
      //     name: CHAIN_CREATE_VIEW_NAME,
      //   }).fullPath
      // } else {
      // }
      window.location.href = prefixLanguage('/cabinet/')
    }
    const { open } = useModalOpener(
      {
        component: markRaw(DoctorSuccessModal),
        onClose: () => {
          setTimeout(() => {
            if (!isGoToCreate) {
              window.location.href = prefixLanguage('/cabinet/')
            }
          }, 1000)
        },
      },
      {
        onClose: () => {
          setTimeout(() => {
            if (!isGoToCreate) {
              window.location.href = prefixLanguage('/cabinet/')
            }
          }, 1000)
        },
      },
      redirectToChainForm
    )
    open()
    isLoad.value = false
  } catch (e) {
    return Promise.reject(e)
  }
}

const request = (sendData, control) => {
  const data = profileTransformFrom(sendData)
  // DEFAULTS.forEach(config => {
  //   config.keys.forEach(key => {
  //     if (!data[key]) {
  //       data[key] = config.value
  //     }
  //   })
  // })
  return useSubmit(send(data), control)
}

const __returned__ = { DoctorSuccessModal, router, props, profileTransformFrom, $t, formRef, form, isLoad, FIELDS, send, request, markRaw, defineAsyncComponent, ref, get useSubmit() { return useSubmit }, get useRouter() { return useRouter }, get accountApi() { return accountApi }, get prefixLanguage() { return prefixLanguage }, get CHAIN_CREATE_VIEW_NAME() { return CHAIN_CREATE_VIEW_NAME }, get useGlobal() { return useGlobal }, get useField() { return useField }, get composeTransformers() { return composeTransformers }, get simplifiers() { return simplifiers }, get CREATE_UPLOAD_URL() { return CREATE_UPLOAD_URL }, get useModalOpener() { return useModalOpener } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})